<template>
  <div>
    <div v-if="case_show" class="popup" @click.self="handle">

      <div class="popup-content" style="padding: 0;width: 1200px">
        <div class="title">查看刊登</div>
        <!--        顶部列表-->
        <div style="padding: 10px;max-height: 600px;overflow: auto">
          <div class="listOfAttributes">
            <div class="listOfAttributes_item">
              <div class="item_title">素材标题</div>
              <div class="item_content">
                <span>{{ list.title }}</span>
              </div>
            </div>
            <div class="listOfAttributes_item">
              <div class="item_title">平台名称</div>
              <div class="item_content">
                <span>{{ list.gugangao_info_title }}</span>
              </div>
            </div>
            <div class="listOfAttributes_item">
              <div class="item_title">广告位置</div>
              <div class="item_content">
                <span>{{ list.address }}</span>
              </div>
            </div>
            <div class="listOfAttributes_item">
              <div class="item_title">链接地址</div>
              <div class="item_content" style="flex-direction: column">
                <a class="_link" style="margin-bottom: 10px" v-for="(link_item, link_index) in list.order_urls" :key="link_index"
                   :href="link_item" target="_blank">{{ link_item }}</a>
              </div>
            </div>
          </div>
          <el-divider content-position="left">发布情况</el-divider>
          <div class="releaseStatus">
            <!--            轮播图-->
            <div class="releaseStatus_item">
              <span>图片截图</span>
              <el-carousel style="width: 500px;height: 250px;overflow: hidden"
                           v-if="list.order_url_image_1.length!==0 && list.order_url_image_1[0]!==''">
                <el-carousel-item v-for="(item, index) in list.order_url_image_1" :key="index">
                  <img style="width: 500px;height: 250px" :src=item>
                </el-carousel-item>
              </el-carousel>
              <!--              <el-carousel v-if="list.order_url_image_1.length!==0 && list.order_url_image_1[0]!==''" ref="carouselRef"-->
              <!--                           :interval="3000" height="300"-->
              <!--                           arrow="always" indicator-position="none"-->
              <!--                           :loop="true">-->
              <!--                <el-carousel-item v-for="(item, index) in list.order_url_image_1" :key="index">-->
              <!--                  <div class="imgContent">-->
              <!--                    <img src="carousel_img" :src=item>-->
              <!--                  </div>-->
              <!--                </el-carousel-item>-->
              <!--              </el-carousel>-->
              <img class="empty" src="@/assets/user/empty.png" v-else>
            </div>
            <div class="releaseStatus_item">
              <span>视频片段</span>
              <video style="max-height: 300px" controls :src="list.order_url_video" v-if="list.order_url_video!==''"
                     muted></video>
              <img class="empty" src="@/assets/user/empty.png" v-else>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      Object,
      default: () => {
      }
    }
  },
  mounted() {
    console.log('查看刊登', this.list);

  },
  data() {
    return {
      case_show: false,
    }
  },
  methods: {
    handle() {
      // this.list.order_url_image = this.list.order_url_image.split(',');
      this.case_show = !this.case_show;
    },

  },
}
</script>

<style lang=scss scoped>
@use '@/scss/poup';

.listOfAttributes {
  width: 100%;
  //background-color: red;
  height: 150px;
  display: flex;
  align-items: center;
  font-size: 14px;

  .listOfAttributes_item {
    height: 140px;
    border-right: 1px solid rgba(204, 204, 204, 1);

    .item_title {
      background: rgba(204, 204, 204, 1);
      height: 30px;
      text-align: center;
      line-height: 30px;
      color: black;
    }

    .item_content {
      padding: 10px;
      display: flex;
      align-items: center;
      width: 100%;
      height: calc(100% - 30px);
      justify-content: center;
      box-sizing: border-box;
    }

    &:nth-child(1) {
      flex: 1;
      //background-color: blue;

      .item_title {
        border-top-left-radius: 10px;
      }
    }

    &:nth-child(2) {
      width: 200px;
      //background-color: yellow;
    }

    &:nth-child(3) {
      width: 200px;
      //background-color: green;
    }

    &:nth-child(4) {
      width: 300px;
      //background-color: blue;
      border: none;

      .item_title {
        border-top-right-radius: 10px;
      }
    }
  }


}

.releaseStatus {
  display: flex;

  .releaseStatus_item {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;

    span {
      margin-bottom: 20px;
    }

    .empty {
      width: 300px;
      height: 300px;
    }
  }
}

.popup-content {
  // background: none;
}

.title {
  height: 40px;
  line-height: 40px;
  padding-left: 20px;
  font-size: 16px;
  //font-weight: 700;
  color: white;
  width: 100%;
  background-color: rgba(16, 140, 221, 1);
}

.video_title {
  width: 100px;
  font-size: 16px;
}

.video {
  max-width: 300px;
  border-radius: 6px;

}

._link {
  display: block;
  font-size: 14px;
  word-break: break-all;
  color: rgba(51, 51, 51, 1);

  &:hover {
    color: rgba(16, 140, 221, 1);
  }
}

.imgContent {
  width: 100%;
  height: 100%;
  //background-color: red;
  display: flex;
  align-items: center;
  justify-content: center;

  .carousel_img {
    width: 100%;
    height: 300px;
  }
}


::v-deep .el-carousel__container {
}

::v-deep .popup-content {
  width: 40%;
  padding: 40px;
}

.popup {
  z-index: 9999;
}
</style>